<template>
  <el-dialog :visible.sync="open" :title="$t('manager.modal.create.title')" :before-close="close" width="390px">
    <el-form v-on:submit.prevent>
      <div class="form-group">
        <label>Firstname</label>
        <input type="text" v-model='manager.fname'/>
      </div>
      <div class="form-group">
        <label>Lastname</label>
        <el-input type="text" v-model='manager.lname'/>
      </div>
      <div class="form-group">
        <label>Email</label>
        <el-input @input="cleanError($event.target)" v-model='manager.email' v-bind:class="{'mb-1' : msgErrorMail, 'mb-6' : !msgErrorMail}"/>
        <p class="text-red-500 pb-1">{{ msgErrorMail ? $t('auth.invalid-mail') : ''}}</p>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button :submit="true" type="primary" @click="save" :loading="saving">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import Avatar from 'vue-avatar'
import { mapActions } from 'vuex'
import VueDropdown from '@kevindesousa/vue-dropdown'

export default {
  name: 'manager-form',

  components: {
    Avatar, VueDropdown
  },

  data () {
    return {
      open: true,
      saving: false,
      errorCode: '',
      EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      msgErrorMail: false,
      manager: {
        fname: null,
        lname: null,
        email: null
      }
    }
  },

  methods: {
    ...mapActions('account', ['addManager']),
    cleanError () {
      this.isProcessing = false
      this.msgErrorMail = false
    },
    validateEmail () {
      if (this.EMAIL_REGEX.test(this.manager.email)) {
        this.isProcessing = false
        this.msgErrorMail = false
      } else {
        this.isProcessing = true
        this.msgErrorMail = true
      }
    },
    save () {
      this.validateEmail()
      if (!this.msgErrorMail) {
        this.addManager({user: this.manager})
          .then(() => {
            this.$notify({
              title: 'Success',
              message: this.$root.$t('notifications.manager.added'),
              type: 'success'
            })
            this.close()
          }).catch((error) => {
            this.errorCode = error.response.data.code
            this.$notify.error({
              title: this.$root.$t('api.' + this.errorCode + '.title'),
              message: this.$root.$t('api.' + this.errorCode + '.message')
            })
          })
      }
    },

    close () {
      this.$emit('close', true)
    }

  }
}
</script>

<style lang="scss" scopped>
.manager {
  box-sizing: border-box;
  padding:12px;
  width: 100%;
  display: inline-block;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 60px 1fr 40px;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas:
      "avatar name actions"
      "avatar email actions"
      "avatar tags actions"
  ;
  grid-column-gap: 24px;
  border-bottom:1px solid #dedede;

  .avatar {
      grid-area: avatar;
  }

  .name {
      grid-area: name;
      font-weight: 600;
  }

  .email {
      grid-area: email;
  }

  .tags {
      grid-area: tags;
  }

  .actions {
      grid-area: actions;
  }
}

.tag {
    display: inline-block;
    width: inherit;
    border-radius: 4px;
    padding:4px 8px;
    color:#fff;
    margin:0;
    font-weight: 400;
    font-size: 13px;
    &.admin {
      background:#3FC380;
    }
    &.manager {
      background:#446CB3;
    }
}
.group-actions {
    text-align: center;
    margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/settings_managers_form.vue